module.exports = __webpack_public_path__ + "img/87570-piconet.36b92e4b.png";